import { createAsyncTypes } from 'utils/ActionCreator'

export const ADD_ASYNC = createAsyncTypes('ADD_ASYNC', 'Mailboxes/Segments')
export const DELETE_MANY_ASYNC = createAsyncTypes('DELETE_MANY_ASYNC', 'Mailboxes/Segments')

export const SET_TAGS_PAGE = 'Mailboxes/Segments/SET_TAGS_PAGE'
export const SET_TAGS_SEARCH = 'Mailboxes/Segments/SET_TAGS_SEARCH'

export const CHANGE_INCLUDED_TAGS = 'Mailboxes/Segments/CHANGE_INCLUDED_TAGS'
export const CHANGE_EXCLUDED_TAGS = 'Mailboxes/Segments/CHANGE_EXCLUDED_TAGS'
export const RESET_TAGS_VALUES = 'Mailboxes/Segments/RESET_TAGS_VALUES'

export const TAGS_REQUEST_ASYNC = createAsyncTypes('TAGS_REQUEST_ASYNC', 'Mailboxes/Segments')
